"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./ticket-channel.js"), exports);
__exportStar(require("./product-config.js"), exports);
__exportStar(require("./ticket-state.js"), exports);
__exportStar(require("./ticket-transitions.js"), exports);
__exportStar(require("./ticket-assignment.js"), exports);
__exportStar(require("./tickets.js"), exports);
__exportStar(require("./ticket-emails.js"), exports);
__exportStar(require("./ticket-priority.js"), exports);
__exportStar(require("./ticket-queue.js"), exports);
__exportStar(require("./ticket-messages.js"), exports);
__exportStar(require("./ticket-closure.js"), exports);
__exportStar(require("./reply-drafts.js"), exports);
__exportStar(require("./inbound-mail.js"), exports);
__exportStar(require("./message-attachments.js"), exports);
__exportStar(require("./attachments.js"), exports);
__exportStar(require("./statistics.js"), exports);
__exportStar(require("./roles.js"), exports);
__exportStar(require("./health.js"), exports);
__exportStar(require("./team.js"), exports);
__exportStar(require("./auth.js"), exports);
__exportStar(require("./mcp-oauth.js"), exports);
__exportStar(require("./api-error.js"), exports);
__exportStar(require("./error-catalog.js"), exports);
__exportStar(require("./queue-settings.js"), exports);
__exportStar(require("./consumers.js"), exports);
__exportStar(require("./consumer-ticket-status.js"), exports);
__exportStar(require("./consumer-webhooks.js"), exports);
//# sourceMappingURL=index.js.map